import React, { Fragment } from 'react';
import { Row, Col, Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import WordcloudSimple from '../Features/SimpleWordCloud';
import moment from 'moment';
import { DateRangeCalendar  } from '../../Components/Features/DatePicker';

import CommonSearches from '../Analytics/CommonSearches';
import IsLoadingBar from '../isLoading';
import Auth from '../../Auth/Auth';

const auth = new Auth();

let today = new Date();
let Sunday = new Date(today.getTime() - today.getDay() * 24 * 3600 * 1000);
 
export default function SimpleWordcloud(props) {
    const [useWords, setWords] = React.useState([]);
    const [originalWords, setOriginalWords] = React.useState([]);
    const [originalCommon, setOriginalCommon] = React.useState([]);
    const [useCommon, setCommon] = React.useState([]);
    const [show, setShow] = React.useState(false);
    const [filteredSearch, setFilteredSearch] = React.useState(false);
    const [relatedWords, setRelatedWords] = React.useState();
    const [editDate, setEditDate] = React.useState(false);
    const [dateFrom, setDateFrom] = React.useState(null);
    const [dateTo, setDateTo] = React.useState(null);
    

    function selectedWord(e){
        setRelatedWords(e.text);
    }

    const dateSelection = async (e,date) => {
        let accessToken = await auth.getToken();
        setEditDate(false);
        setShow(false);

        fetch('/api/wordCloudClient', {
            method : "GET",
            headers : {
                'Authorization': "Bearer " + accessToken,
                withCredentials : true,
                crossDomain: true,
                datefilter: moment.utc(date.selection.endDate).format('YYYY/MM/DD'),
                dateFrom: moment.utc(date.selection.startDate).format('YYYY/MM/DD')
            }
        }).then(response => {
            if(response.status !== 200)
            {   
                let payload = [{
                    status : response.status,
                    rawmsg : response.statusText,
                    cleanmsg : response.status + " was thrown with the message of " + response.statusText + " on " + response.url,
                    location: response.url,
                    timestamp : Date.now(),
                }];
                throw {
                    payload: payload,
                    error: new Error()
                };
            }
            return  response.json();
        }).then(data => {
            let words = data[0];
            let wordArr = [];
            for(let i = 0; i < words.length; i++){
                let word = {
                    text: words[i].Word,
                    value: words[i].WordCount,
                    score: words[i].Score,
                };
                wordArr.push(word);
            }
            setWords(wordArr);
            setCommon(words.slice(0,20));
            setShow(true);
            setDateFrom(moment.utc(date.selection.startDate).format('YYYY/MM/DD'));
            setDateTo(moment.utc(date.selection.endDate).format('YYYY/MM/DD'));
            setFilteredSearch(true);             
        }).catch((error) => {
            window.apiError(error);
        });
    };

    const showMonth = () => {
        setShow(false);
        setTimeout(function(){
            setWords(originalWords);
            setCommon(originalCommon.slice(0,20));
            setFilteredSearch(false);
            setDateFrom(null);
            setShow(true);
        },1000);
        
    };

    React.useEffect(() => {
        let words = props.words;
        let wordArr = [];
        for(let i = 0; i < words.length; i++){
            let data = {
                text: words[i].Word,
                value:words[i].WordCount,
                score: words[i].Score,
            };
            wordArr.push(data);
        }
        setWords(wordArr);
        setOriginalWords(wordArr);
        setCommon(words.slice(0,20));
        setOriginalCommon(words.slice(0,20));
        setShow(true);
    }, [props.words]);

    if(!show){
        return (
            <IsLoadingBar />
        );
    } 
    
     return (
            <Row>                
                <Col lg={{ span: 12 }} style={{width : '50vw', height: '65vh'}}>
                    <div className="mb-0">
                        <Fragment>
                            <strong>Currently Fetching Data {dateFrom !== null ? `Currently Fetching Data from ${moment.utc(dateFrom).format('YYYY/MM/DD')} to ${moment.utc(dateTo).format('YYYY/MM/DD')}` : `for month of ${moment.utc(props.searchesDate).format('MMMM')}`} </strong>
                            
                            <OverlayTrigger
                                placement={"top"}
                                overlay={
                                <Tooltip id={`tooltip-top`}>
                                    Date Range
                                </Tooltip>
                                }
                            >
                                <Button variant="link" onClick={() => setEditDate(!editDate)}><i className="fas fa-calendar-day"></i></Button>
                            </OverlayTrigger>
                                        
                            {filteredSearch && (
                                <OverlayTrigger
                                    placement={"top"}
                                    overlay={
                                    <Tooltip id={`tooltip-top`}>
                                        Back to Previous Month View
                                    </Tooltip>
                                    }
                                >
                                    <Button variant="link" onClick={() => showMonth()}><i class="far fa-calendar"></i></Button> 
                                </OverlayTrigger>
                                
                            )}                                                       
                        </Fragment>   
                        {dateFrom !== null && (
                            <Fragment>
                                <p style={{ marginTop: "-10px", marginBottom: "0px" }}><small style={{color: 'red'}}>Drill down only available for monthly data</small></p>   
                            </Fragment>                            
                        )}                                               
                    </div>
                    
                    {editDate && (
                         <DateRangeCalendar selection={(e,dates) => dateSelection(e,dates)} />    
                    )} 
                    <WordcloudSimple data={useWords} relatedWords={(e) => selectedWord(e)} />                
                </Col>
                <Col lg={{span : 12}}>
                    <strong>Top 20 searched words</strong>
                    <CommonSearches words={useCommon.slice(0,20)} date={moment.utc(Sunday).format('YYYY/MM/DD')} searchesDate={props.searchesDate} relatedWords={relatedWords} area={props.area} isFilteredSearch={filteredSearch} />
                </Col>
            </Row>         
        );
}